<template>
<div id="sheet-page" :class="{'pa-2 ma-2': $vuetify.breakpoint.smAndUp}" style="padding-bottom: 70px !important">

    <v-container fluid :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-card class="mx-md-3" v-if="$vuetify.breakpoint.mdAndUp" tile flat>
            <v-card-text class="py-2">
                <v-row class="title align-center">
                    <v-col md="7" cols='12' class="py-0">
                        <div class="title d-flex align-center">
                            <v-btn color="primary" text icon @click="prevPeriod()">
                                <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            <v-menu transition="scale-transition" offset-y v-model="menu_period_start" :close-on-content-click="false">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" flat solo readonly :placeholder="$t('sheet.from')" v-model="period.start" @input="menu_period_stop = true" hide-details style="max-width: 150px"></v-text-field>
                                </template>
                                <v-date-picker v-model="period.start" :min="today" no-title @input="menu_period_start = false, menu_period_stop = true,period.stop=period.start" width="265" :locale="$vuetify.lang.current"></v-date-picker>
                            </v-menu>
                            <v-icon small class="mx-1">arrow_forward</v-icon>
                            <v-menu transition="scale-transition" offset-y v-model="menu_period_stop" :close-on-content-click="false">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" flat solo readonly :placeholder="$t('sheet.until')" v-model="period.stop" @input="getSheet();menu_period_stop = false" hide-details style="max-width: 150px"></v-text-field>
                                </template>
                                <v-date-picker v-model="period.stop" :min="period.start" show-current="2013-07" no-title @input="getSheet();menu_period_stop = false" width="265" :locale="$vuetify.lang.current"></v-date-picker>
                            </v-menu>
                            <v-btn color="primary" text icon @click="nextPeriod()">
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn dark icon v-on="on">
                                        <v-icon color="primary">today</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(item, index_time) in time_intervals" :key="'time'+index_time" @click="goToInterval(item.value)">
                                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-progress-linear v-if="loading_data" :indeterminate="true" height="3" class="ma-0 progress-bar"></v-progress-linear>
        </v-card>
        <v-card v-else flat tile>
            <v-container fluid>
                <v-date-picker class="mx-auto" v-model="mobile_picker" :min="today" no-title @input="mobileDate()" width="280"></v-date-picker>
            </v-container>
        </v-card>
        <v-divider class="mx-md-3" />
        <div class="mx-md-3">
            <v-alert class="ma-0" :value="true" type="info">
                <span class="title">
                    {{ $t('sheet_room_meal.info_message') }}
                </span>
            </v-alert>

        </div>
        <v-divider class="mx-md-3" />

        <v-card v-if="room_types.length == 0 && !loading_data" tile flat>
            <v-card-text>
                <div class="pa-3 important text-center">
                    {{ $t('sheet.message_no_room') }}
                </div>
            </v-card-text>
        </v-card>
        <div v-else>
            <template v-if="!loading_data">
                <im-sheet-room ref="sheet-card-room" :weekend="weekend" :room_types="room_types" :sheet="sheet" :days="days" @bulkRoom="dialog_room=true" @select="select" @scroll="scroll" />
                <im-sheet-meal ref="sheet-card-meal" :weekend="weekend" :sheet="sheet" :days="days" @bulkMeal="dialog_meal=true" @select="select" @scroll="scroll" />
            </template>
        </div>

    </v-container>

    <!--  dialog inventory -->
    <v-dialog v-model="dialog_room" max-width="800px" persistent :fullscreen="$vuetify.breakpoint.smAndDown">
        <im-rooms-modal :room_types="room_types" :hotel_id="hotel.id" :currency="hotel.currency" :dialog_status="dialog_room" :date_period="period" @close="dialog_room= false;" @refresh="getSheet()" />
    </v-dialog>
    <!-- ./ dialog inventory  -->
    <!--  dialog pricing -->
    <v-dialog v-model="dialog_meal" max-width="800px" persistent :fullscreen="$vuetify.breakpoint.smAndDown">
        <im-meals-modal :room_types="room_types" :hotel_id="hotel.id" :currency="hotel.currency" :dialog_status="dialog_meal" :date_period="period" @close="dialog_meal= false;" @refresh="getSheet()" />
    </v-dialog>
    <!-- ./ dialog pricing -->
</div>
</template>
<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import IMFooter from '../../components/utils/IMFooter.vue';
import RoomsModal from '../../components/items/SheetRoomMeal/RoomsModal.vue';
import MealsModal from '../../components/items/SheetRoomMeal/MealsModal.vue';
import SheetRoom from '../../components/items/SheetRoomMeal/SheetCardRoom.vue';
import SheetMeal from '../../components/items/SheetRoomMeal/SheetCardMeal.vue';

export default {
    props: ['hotel'],
    name: `sheet`,
    components: {
        'im-rooms-modal': RoomsModal,
        'im-meals-modal': MealsModal,
        'im-sheet-room': SheetRoom,
        'im-sheet-meal': SheetMeal,
        "im-footer": IMFooter,
    },

    data() {
        return {
            admin: false,
            context: null,
            weekend: [],
            mobile_picker: null,
            menu_period_start: null,
            menu_period_stop: null,
            loading_data: true,
            loading_save: false,
            dialog_room: false,
            dialog_meal: false,

            selected: null,

            room_types: [],
            previous_plans_selected: [],
            days: [],
            sheet: {
                meal_types: {},
                room_types: {}
            },
            edited_sheet: {
                meal_types: {},
                room_types: {}
            },
            meal_types: ["breakfast", "lunch", "dinner", "all-inclusive"],
            period: {
                start: null,
                stop: null
            },

            today: new Date()
                .toISOString()
                .substr(0, 10),

        }
    },

    computed: {
        time_intervals() {
            return [
                {
                    text: this.$t('sheet.period.week'),
                    value: 7
                }, {
                    text: '2 ' + this.$t('sheet.period.weeks'),
                    value: 14
                }, {
                    text: this.$t('sheet.period.month'),
                    value: 30
                }, {
                    text: '3 ' + this.$t('sheet.period.months'),
                    value: 90
                },
            ]
        },
        settings() {
            return [
                {
                    text: this.$t('sheet.settings.edit_restrictions'),
                    value: "restrictions"
                }
            ]
        },
    },

    async mounted() {
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    watch: {

        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                } else {
                    this.getAllItems();
                }
            },
            deep: true,
            immediate: true
        },
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getAllItems() {
            if(this.$vuetify.breakpoint.smAndDown) {
                this.period.start = this.today
                this.period.stop = this.today
            }
            if(!this.hotel.id) {
                return
            }
            this.getActiveRooms()
                .then(() => this.getHotelInfo())
                .then(() => this.getSheet())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {});
        },

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Nu exista acest hotel si veti fi redirectionat");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {

                });
        },

        getSheet() {
            this.loading_data = true;
            if(!this.hotel.id) {
                return
            }
            this.sheet = {};
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/components';

            // setup query params
            let params = {
                params: {
                    date_start: this.period.start,
                    date_stop: this.period.stop,
                    hotel_id: this.hotel.id,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.period = response.data.period;
                    this.days = response.data.days;
                    this.nr_steps = response.data.days.length;

                    if(response.data.sheet) {
                        if(response.data.sheet.meal_types) {
                            this.sheet.meal_types = response.data.sheet.meal_types;
                        }
                        if(response.data.sheet.room_types) {
                            this.sheet.room_types = response.data.sheet.room_types;
                        }
                        this.populateMissingData();
                    } else {
                        this.populateMissingData();
                    }
                    this.loading_data = false;
                    this.loading = false;
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if(document.getElementById('sheet-table-meals')) {
                            let scroll = document.getElementById('sheet-table-meals')
                                .offsetWidth - document.getElementById('sheet-meals')
                                .offsetWidth + 10;
                            if(scroll > 0) {
                                this.max = scroll;
                            } else {
                                this.max = 0;
                            }
                        }
                    });
                });
        },

        getHotelInfo() {

            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + this.hotel.id;


            return this.$axios.get(endpoint)
                .then(response => {
                    this.context = response.data.context;
                    this.weekend = response.data.static.defaults.weekend;

                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        getActiveRooms() {

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    let rooms = [];
                    response.data.data.forEach(function (room, index) {
                        if(!room.close_out) {
                            room.price = null;
                            rooms.push(room);
                        }
                    }.bind(this))
                    this.room_types = rooms;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        nextPeriod() {
            this.period.start = this.period.walk.next.date_start;
            this.period.stop = this.period.walk.next.date_stop;
            this.getSheet();
        },

        prevPeriod() {
            this.period.start = this.period.walk.prev.date_start;
            this.period.stop = this.period.walk.prev.date_stop;
            this.getSheet();
        },

        goToInterval(value) {
            let date = this.$moment(this.today, "YYYY-MM-DD")
                .add(value, 'days')
                .format("YYYY-MM-DD");
            this.period.start = this.today;
            this.period.stop = date;
            this.getSheet();
        },

        populateMissingData() {
            //verify the inventory
            if(!this.sheet.room_types) {
                this.sheet.room_types = {};
            }
            this.room_types.forEach(function (room, index_room) {
                if(!this.sheet.room_types[room.id]) {
                    this.$set(this.sheet.room_types, [room.id], {});
                    this.days.forEach(function (day, index_day) {
                        this.$set(this.sheet.room_types[room.id], day, {
                            'component_id': room.id,
                            'component_type': 'room_types',
                            'date': day,
                            'hotel_id': this.hotel.id,
                            'price': 0,
                        });
                    }.bind(this))
                } else {
                    this.days.forEach(function (day, index_day) {
                        if(!this.sheet.room_types[room.id][day]) {
                            this.$set(this.sheet.room_types[room.id], day, {
                                'component_id': room.id,
                                'component_type': 'room_types',
                                'date': day,
                                'hotel_id': this.hotel.id,
                                'price': 0,
                            });
                        }
                    }.bind(this))
                }
            }.bind(this))
            //verify the pricing
            if(!this.sheet.meal_types) {
                this.sheet.meal_types = {};
                // this.$set(this.sheet, inventory, {});
            }
            this.meal_types.forEach(function (meal, index_meal) {
                if(!this.sheet.meal_types[meal]) {
                    this.$set(this.sheet.meal_types, [meal], {});
                    this.days.forEach(function (day, index_day) {
                        this.$set(this.sheet.meal_types[meal], day, {
                            'component_id': meal,
                            'component_type': 'meal_types',
                            'date': day,
                            'hotel_id': this.hotel.id,
                            'price': 0,
                        });
                    }.bind(this))
                } else {
                    this.days.forEach(function (day, index_day) {
                        if(!this.sheet.meal_types[meal][day]) {
                            this.$set(this.sheet.meal_types[meal], day, {
                                'component_id': meal,
                                'component_type': 'meal_types',
                                'date': day,
                                'hotel_id': this.hotel.id,
                                'price': 0,
                            });
                        }
                    }.bind(this))
                }
            }.bind(this))
        },

        select: function (type) {
            this.selected = type;
        },

        scroll: function () {
            if(this.selected == "meal") {
                this.$refs['sheet-card-room'].$refs['sheet-wrapper'].scrollLeft = event.target.scrollLeft;
            }
            if(this.selected == "room") {
                this.$refs['sheet-card-meal'].$refs['sheet-wrapper'].scrollLeft = event.target.scrollLeft;
            }
        },


        mobileDate() {
            this.period.start = this.mobile_picker;
            this.period.stop = this.mobile_picker;
            this.getSheet();
        },


    }
}
</script>
<style >
.sheet-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 !important;
}

/* .sheet-wrapper::-webkit-scrollbar {
    height: 10px;
}

.sheet-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #808080;
    border-radius: 5px;
}

.sheet-wrapper::-webkit-scrollbar-thumb {
    background: #808080;
    border-radius: 5px;
}

.sheet-wrapper::-webkit-scrollbar-thumb:hover {
    background: #808080;
} */

.sheet {
    border-spacing: 0;
}

.sheet thead th {
    top: 0;
    position: -webkit-sticky;
    position: sticky;
}

.sheet thead th:first-child {
    left: 0;
    z-index: 1;
}

.sheet tbody th {
    left: 0;
    position: -webkit-sticky;
    position: sticky;
}

.sheet tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.sheet-date {
    left: 275px;
    position: -webkit-sticky;
    position: sticky;
    font-size: 12px;
}

.sheet-header {
    font-size: 12px;
    text-align: left;
    width: 275px;
    min-width: 275px;
    max-width: 275px;
    background-color: white;
    z-index: 1;
    border: 1px solid rgba(0, 0, 0, .1);
    padding: 4px;
}

.sheet-cell {
    min-width: 80px;
    max-width: 100px;
    padding: 4px;
    border: 1px solid rgba(0, 0, 0, .1);
}

@media screen and (max-width: 600px) {
    .sheet-header {
        width: 190px;
        min-width: 190px;
        max-width: 190px;
    }
}

.sheet-input {
    width: 100%;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-input-left {
    width: calc(50% - 2px);
    margin-right: 2px;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-input-right {
    width: calc(50% - 2px);
    margin-left: 2px;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-switch-left {
    padding: 0 !important;
    margin: 0 2px 0 0 !important;
    min-width: 0 !important;
    width: calc(50% - 2px);
}

.sheet-switch-right {
    padding: 0 !important;
    margin: 0 0 0 2px !important;
    min-width: 0 !important;
    width: calc(50% - 2px);
}

.weekday {
    background-color: rgba(0, 0, 0, .025);
}

.weekend {
    background-color: rgba(0, 0, 0, .075);
}
</style>
